var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 21L17.4697 21.5303C17.6842 21.7448 18.0068 21.809 18.287 21.6929C18.5673 21.5768 18.75 21.3033 18.75 21H18ZM6 21H5.25C5.25 21.3033 5.43273 21.5768 5.71299 21.6929C5.99324 21.809 6.31583 21.7448 6.53033 21.5303L6 21ZM12 15L12.5303 14.4697C12.2374 14.1768 11.7626 14.1768 11.4697 14.4697L12 15ZM8 4.75H16V3.25H8V4.75ZM17.25 6V21H18.75V6H17.25ZM6.75 21V6H5.25V21H6.75ZM18.5303 20.4697L12.5303 14.4697L11.4697 15.5303L17.4697 21.5303L18.5303 20.4697ZM11.4697 14.4697L5.46967 20.4697L6.53033 21.5303L12.5303 15.5303L11.4697 14.4697ZM16 4.75C16.6904 4.75 17.25 5.30964 17.25 6H18.75C18.75 4.48122 17.5188 3.25 16 3.25V4.75ZM8 3.25C6.48122 3.25 5.25 4.48122 5.25 6H6.75C6.75 5.30964 7.30964 4.75 8 4.75V3.25Z",
    fill: "#0091FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.07fd959e3da64b6e8f78f8baca5eedee.svg";
export { ForwardRef as ReactComponent };